// src/membership/SubscriptionPage.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { loadStripe } from '@stripe/stripe-js';
import '../config/firebaseConfig'; 

// Stripe yayınlanabilir anahtarın. Bunun doğru ve geçerli olduğundan emin ol.
const stripePromise = loadStripe('pk_live_JsTxjnAybJ8uQaE8enYECiCM00P6nQScyb');

const SubscriptionPage = () => {
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubscription = async (e) => {
        e.preventDefault();
        if (loading) return;

        setLoading(true);
        setError(null);

        try {
            const functions = getFunctions();
            const createStripeCheckoutSession = httpsCallable(functions, 'createStripeCheckoutSession');
            
            const priceId = 'price_1SAbgjKt79DlsQLbYPRa5dip';

            const { data } = await createStripeCheckoutSession({ 
                fullName,
                email, 
                priceId,
                password
            });
            
            const sessionId = data.id;

            // --- YENİ DEBUG KODU ---
            console.log("Stripe'a yönlendirme yapılıyor. Session ID:", sessionId);
            if (!sessionId) {
                // Bu hata, backend'in beklendiği gibi bir ID döndürmediği anlamına gelir.
                throw new Error("Backend'den geçerli bir Session ID alınamadı.");
            }
            // --- BİTİŞ ---

            const stripe = await stripePromise;
            // Bu fonksiyon tarayıcıyı yönlendirmeye çalışır.
            const { error } = await stripe.redirectToCheckout({ sessionId });

            // Bu blok genellikle ağ hatası gibi yönlendirme başlamadan önce oluşan hatalar için çalışır.
            if (error) {
                console.error("Stripe redirectToCheckout BİR HATA DÖNDÜRDÜ:", error);
                setError(error.message);
                setLoading(false);
            }
            // Başarılı yönlendirmede bu kod bloğuna ulaşılmaz.

        } catch (err) {
            // --- GÜNCELLENMİŞ HATA YAKALAMA ---
            // Bu blok, Firebase Cloud Function çağrısı veya diğer 'await' işlemleri sırasında oluşan hataları yakalar.
            console.error("TRY-CATCH BLOK'U HATA YAKALADI:", err);
            
            if (err.message) {
                 setError(err.message);
            } else {
                 setError('Could not initiate the subscription process. Please try again.');
            }
            setLoading(false);
            // --- BİTİŞ ---
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 'calc(100vh)', paddingTop: '60px', paddingBottom: '20px' }}> 
            <div className="col-md-6 col-lg-5" style={{ maxWidth: '450px' }}>
                <div className="card shadow-sm">
                    <div className="card-body p-4 p-md-5">
                        <h2 className="text-center mb-1">Subscribe</h2>
                        <p className="text-center text-muted mb-4">Join for £4.99 / month</p>
                        
                        {error && <div className="alert alert-danger">{error}</div>}

                        <form onSubmit={handleSubscription}>
                            <div className="mb-3">
                                <label htmlFor="fullName" className="form-label">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="fullName"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    placeholder="Enter your full name"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email address</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="you@example.com"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Create a Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="You'll use this to log in later"
                                    required
                                    minLength="6"
                                />
                            </div>
                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? 'Processing...' : 'Subscribe & Pay with Stripe'}
                                </button>
                            </div>
                        </form>

                        <div className="text-center mt-3">
                            <p className="mb-0">
                                Already a member? <Link to="/login">Log In</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPage;